import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TwitterPostsComponent } from './Components/twitter-posts/twitter-posts.component';


export const twitterRouting: Routes = [
  {
    path: '',
    component: TwitterPostsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(twitterRouting)],
  exports: [RouterModule],
})
export class TwitterRoutingModule {}
